import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';

const USER_ROLES = [
  {
    value: 'engineering',
    label: 'Engineering',
  },
  {
    value: 'data',
    label: 'Data',
  },
  {
    value: 'product-management',
    label: 'Product management',
  },
  {
    value: 'founder',
    label: 'Founder',
  },
  {
    value: 'leadership',
    label: 'Leadership',
  },
  {
    value: 'marketing',
    label: 'Marketing',
  },
  {
    value: 'sales-customer-success',
    label: 'Sales/Customer success',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export const UserRole = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (role: string) => void;
}) => {
  return (
    <FormControl component="fieldset">
      <FormLabel required>Select your role</FormLabel>
      <RadioGroup
        aria-label="user-role"
        name="user-role"
        value={value}
        onChange={(_e, role) => onChange(role)}
      >
        {USER_ROLES.map(role => (
          <FormControlLabel
            key={role.value}
            value={role.value}
            control={<Radio color="primary" />}
            label={role.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
